"use client";

import { useLayoutEffect, useRef, useState } from "react";

type UseIsElementTruncatedOptions = {
  enabled?: boolean;
};

function useIsElementTruncated<T extends HTMLElement = HTMLElement>(
  remeasureKey?: unknown,
  options?: UseIsElementTruncatedOptions,
) {
  const ref = useRef<T>(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const enabled = options?.enabled ?? true;

  useLayoutEffect(() => {
    const element = ref.current;

    if (!element || !enabled) {
      return;
    }

    const updateTruncation = () => {
      setIsTruncated(element.scrollHeight > element.clientHeight + 1);
    };

    updateTruncation();

    const resizeObserver = new ResizeObserver(updateTruncation);
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, [enabled, remeasureKey]);

  return { isTruncated, ref };
}

export { useIsElementTruncated };
